import Utils from '@/utils/utils';
import { ReactComponent as AR } from '@/assets/icons/country-en.svg';
import { ReactComponent as BR } from '@/assets/icons/country-en.svg';
import { ReactComponent as CN } from '@/assets/icons/country-en.svg';
import { ReactComponent as DE } from '@/assets/icons/country-en.svg';
import { ReactComponent as ES } from '@/assets/icons/country-en.svg';
import { ReactComponent as EN } from '@/assets/icons/country-en.svg';
import { ReactComponent as FR } from '@/assets/icons/country-en.svg';
import { ReactComponent as ID } from '@/assets/icons/country-en.svg';
import { ReactComponent as IN } from '@/assets/icons/country-in.svg';
import { ReactComponent as IT } from '@/assets/icons/country-it.svg';
import { ReactComponent as JP } from '@/assets/icons/country-jp.svg';
import { ReactComponent as KR } from '@/assets/icons/country-kr.svg';
import { ReactComponent as NL } from '@/assets/icons/country-en.svg';
import { ReactComponent as RU } from '@/assets/icons/country-en.svg';
import { ReactComponent as TR } from '@/assets/icons/country-en.svg';
import { ReactComponent as TW } from '@/assets/icons/country-en.svg';

/**
 * 购买信息map
 */
const countryIcon = new Map([
  ['ar', <AR />],
  ['br', <BR />],
  ['cn', <CN />],
  ['de', <DE />],
  ['es', <ES />],
  ['en', <EN />],
  ['fr', <FR />],
  ['id', <ID />],
  ['in', <IN />],
  ['it', <IT />],
  ['jp', <JP />],
  ['kr', <KR />],
  ['nl', <NL />],
  ['ru', <RU />],
  ['tr', <TR />],
  ['tw', <TW />],
]);

export default countryIcon.get(Utils.getLanguage());
